import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  propertyAddressCell: {
    '&:hover': {
      cursor: 'pointer'
    }
  },
  title: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: '10px'
  },
  amount: {
    verticalAlign: 'middle',
    marginLeft: '10px'
  },
  mainCell: {
    width: '860px'
  },
  filtersWrapper: {
    marginBottom: '10px',
    background: palette.gradients.white,
    padding: '24px',
    boxShadow: palette.shadows.light,
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  searchWrapper: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '24px'
    }
  },
  pageWrapper: {
    paddingTop: '32px'
  }
}));
export default useStyles;